export default {
    "enter_email": "请输入邮箱",
    "enter_correct_emali":"请输入正确的邮箱",
    "enter_verification_code": "请输入验证码",
    "send": "发送",
    "agree_terms_one": "已同意",
    "agree_terms_two": "《用户使用许可及服务协议》",
    "agree_terms_three": "和",
    "agree_terms_four": "《数龙信息技术（上海）有限公司隐私政策》",
    "register_login": "注册/登录", 
    "competition_registration": "“数龙杯”全球AI",
    "competition_registration_one":"创新大赛 2026 参赛报名问卷",
    "agreements_notice": "您需要阅读以下两份协议内容：",   
    "agreement_3":"和",
    "agreement_1": "《“‘数龙杯’全球 AI 创新大赛”参与者协议》",
    "agreement_2": "《“‘数龙杯’全球 AI 创新大赛”个人信息保护政策》",
    "read_and_understand": "为了保障您的合法权益，请您详细阅读并理解上述协议的所有内容，避免有任何遗漏。",
    "click_next": "当您点击【下一页】时，即代表您已同意协议内容。",
    "agree_and_continue": "我已阅读，并同意以上内容",
    "next": "下一页",
    "enter_phone_number": "请输入手机号",
    "enter_correct_phone_number":"请输入正确的手机号",
    "check_agreement":"请勾选协议",
    
    "team_name": "团队名称",
    "team_leader_name": "联系人姓名",
    "team_leader_mobile": "联系方式：",
    "team_leader_mobile_type": "(手机号/QQ号/微信/邮箱)",
    "team_leader_mobile_notice": "请注意：您需要至少填写一项，以便我们与您在线上取得联系。",
    "packaging_instructions_new": "团队介绍：",
    "packaging_instructions_new_type": "(上传附件，压缩包附件大小不超过20M)",
    "packaging_instructions_new_notice_one":"请注意：",
    "packaging_instructions_new_notice":"多个文件请打包上传，多次上传仅支持最后一次上传的文件。",
    "work_name":"产品名称",
    "work_type":"类型",
    "work_type_one":"游戏",
    "work_type_two":"应用",
    "work_description":'产品介绍',
    "related_materials_baidu": "产品相关素材 - 百度网盘链接",
    "related_materials_baidu_en": "产品相关素材",
    "work_platform":'申报奖项：',
    "work_platform_type":'(多项，最多选3项)',
    "work_platform_one":"最佳AI游戏奖",
    "work_platform_two":"最佳AI应用奖",
    "work_platform_three":"最具商业价值奖",
    "work_platform_four":"最佳新秀奖（优先大学生团队）",
    "work_platform_five":"最佳国际团队奖（限境外团队报名）",
    "art_musicSoundOriginality":"是否愿意同步报名参加“文创上海”智能未来+大赛",
    "art_musicSoundOriginality_one":"是",
    "art_musicSoundOriginality_two":"否",




    "team_leader_qq": "团队负责人QQ号",
    "no_qq_or_wechat": "如果您没有QQ或微信账号，可在对应文本框内填写“无”。",
    "provide_qq_or_wechat": "请注意：您需要至少填写QQ或微信中的一个，以便我们与您线上取得联系。",
    "team_leader_wechat": "团队负责人微信",
    "team_leader_email": "团队负责人邮箱",
    "team_members_info": "团队成员信息",
    "packaging_instructions": "请打包上传团队内所有成员包含以下信息的文件（压缩包附件大小不超过20M）：",
    "member_info_1": "姓名",
    "member_info_2": "职业及所在公司 / 学校",
    "member_info_3": "专业",
    "member_info_4": "毕业年份",
    "member_info_5": "学生身份证明文件",
    "student_proof_requirements": "关于学生身份证明：包含学信网认证报告、学生证、毕业证书其中的任意一份的电子扫描件或者清晰照片。",
    "verification_failure": "如果因证明文件的清晰度等问题，导致无法验证学生身份真实性，则报名无效。",
    "game_application_name": "游戏/应用名称",
    "game_application_type": "游戏/应用类型",
    "game_application_platforms": "游戏/应用平台",
    "game_application_one": "主机",
    "game_application_two": "手机",
    "game_application_three": "其他",
    "game_application_introduction": "游戏/应用简介",
    "originality": "美术/音乐/音效素材是否为原创",
    "originality_one": "完全原创",
    "originality_two": "部分原创",
    "originality_three": "非原创",
    "ai_technology_use": "游戏哪部分功能使用了 AI技术",

    "related_materials":'相关材料：',
    "executable_file": "可执行文件",
    "promotional_posters": "宣传海报图（选填）：宽高比例16:9（横版）与9:16（竖版）各一份，分辨率尽可能高。",
    "video_materials": "相关视频：包括宣传视频和实机演示视频。相关视频后续将用于入选作品的线上线下宣传。",
    "other_introduction": "其他介绍材料：包括但不限于，游戏/应用Logo、团队Logo、其他相关说明文件等。",
    "requirement":'网盘链接要求：',
    "netdisk_requirements": "将游戏/应用相关材料分类、打包并上传至百度网盘，创建分享链接并设置永久有效。",
    "sharing_link": "将分享链接及提取码复制粘贴至下框。",
    "upload_faile":"上传失败，请稍后再试",
    
    "attachment_ask":'附件要求',
    "attachment_requirements": "将游戏/应用相关材料分类、打包并上传至邮箱ai.cht@digiloong.com。",

    "sure_submit":'提交',
    "back":"取消",
    "sure_sub_dia":"是否确认提交？",

    "home":'首页',
    "introduction":"比赛介绍",
    "schedule":'赛程安排',
    "guide":"参赛须知",
    "pane":'评审嘉宾',
    "award":"奖项设置",
    "news":'资讯动态',
    "contact_us":"联系我们",
    "shulong":"数龙365",

    "follow_us":"关于我们",

    "guid_units":"指导单位",
    "games_publishing":"中国音数协游戏工委",
    "pu_dong":'浦东新区区委宣传部（区文体旅游局）',
    "pu_culture":"上海市文化创意产业促进会",
    "shanghai_online":'上海市网络游戏行业协会',
    "macau":"澳门澳琴文化科技产业协会",

    "strategic_partner":"战略合作伙伴",
    "chinaJoy":"ChinaJoy",

    "chief_partnership_park":"首席合作园区",
    "shanghai_pudong":"上海浦东软件园",

    "chief_in":"首席孵化器伙伴",
    "lighthouse":"光源资本",
    "eastern":"钟鼎资本",
    "chief_financial":"首席金融财经合作媒体",
    "cai_lian":"财联社",



    "chief_media":"首席媒体伙伴",
    "paper":"澎湃新闻",
    "chief_propagation":"首席传播合作媒体",
    "chao_news":"潮新闻",

    "chief_creative":"首席创投合作媒体",
    "thirty_six_kr":"36氪",
    

    "chief_start":"首席创业伙伴",
    "shanghai_technology":"上海市大学生科技创业基金会",

    "chief_open_source":"首席开源社区合作伙伴",
    "magic_dabang":"魔搭社区",

    "cooperative_media":"合作媒体",
    "game_inn":"游戏客栈",
    "game_artist":"游戏艺术家",

    "project_incubation":"项目孵化合作伙伴",
    "jufan":"聚变工坊",
    "pu_soft":"浦软孵化器",

    "china_audio":'中国音像与数字出版协会',
    "shanghai_online":"上海市网络游戏行业协会",
    "shengqu":"盛趣资本",

    "hold_down":"按住滑块拖动",
    "verification":"请完成安全验证",

    "file_size_limit":"上传文件大小不能超过 20MB!",
    "question_complete":"请将问卷信息填写完整",

    "add_determined":"PS：更多嘉宾陆续增加中......",
    "up_limit":"文件上传次数超限",
    "error_time":'请求超时，请稍后再试',



    "比赛介绍 ":"",
    "Competition_one":'"数龙杯"全球AI创新大赛由 ',
    "Competition_two":'世纪华通',
    "Competition_three":'发起，致力于汇聚全球顶尖的开发者与创新团队，共同探索AI技术在游戏开发以及各类应用场景中的创新突破。大赛以激发创意、推动技术革新为核心目标，旨在通过搭建一个全球性的交流与合作平台，促进产业链上下游各方的深度互动，加速AI技术在游戏领域的落地应用，从而推动AI游戏产业生态的繁荣发展。',
    
    "赛程安排":"",
    "Competition_report":"报名及海选",
    "Competition_report_date":"4月2日-5月31日",
    "Competition_frist":"初选",
    "Competition_frist_date":"6月1日-6月15日",
    "Competition_se":"复选及入围",
    "Competition_se_date":"6月16日—6月30日",
    "Competition_down":"线下评审",
    "Competition_down_date":"7月中旬",
    "Competition_grade":"线下颁奖",
    "Competition_grade_date":"7月31日",

    "参赛须知":"",
    "Target_audience":"征集对象",
    "AI_developers":'全球范围内的游戏开发者、AI开发者、高校学生及相关爱好者。',
    "Registration_requirements":"参赛要求",
    "Requirements_one":"参赛者可选择以个人或团队形式报名，但不得重复报名。报名时需按照组委会要求提交相关证明材料，以便进行身份核实。",
    "Requirements_two":"参赛者提交的所有内容，包括但不限于团队及游戏名称、游戏内容等，必须严格遵守国家法律法规、政策规章及公序良俗。严禁出现侵犯第三方知识产权或其他合法权益的内容，禁止涉及政治、暴力、色情、人身攻击（包括但不限于侮辱、诽谤）、反人类、亵渎宗教等内容。一经发现，主办方有权取消参赛资格并收回已发放的奖励。",
    "Requirements_three":" 参赛者必须遵循公平公正的原则，确保作品的真实性。严禁通过不正当手段参与比赛，例如提供虚假信息、雇佣他人代为参赛等。一旦核实存在此类行为，将立即取消其参赛及获奖资格。",
    
    "Work_specifications":"作品规范",
    "Work_one":"作品需围绕AI在游戏中的实际使用，海选阶段需要提交作品说明文档及演示视频；复审及线下评审环节需要确保其具有应用性和可演示性。",
    "Work_two":"作品可融合创新的AI游戏玩法、AI应用场景以及技术实现方式。",
    "Work_three":"若作品中使用了AI技术生成的资产，须在游戏介绍中明确标注“本游戏包含 AI 生成的资产”，并详细说明使用部分。若存在故意隐瞒行为，世纪华通有权取消该参赛者的参赛资格或收回已发放的奖励。因使用AI技术引发的版权争议，由参赛者自行处理争议问题并承担相应法律责任。",
    
    "Submission":"作品提交",
    "Submission_des":"参与者需点击页面上方的按钮，完成账号注册并成功登录，在规定的截止日期前填写完整的报名信息。在作品征集截止时间前，参赛者可以对已提交的游戏进行多次更新和完善，以截止时间前最终提交结果为准。",
    
    "Copyright":"素材版权说明",
    "Copyright_dec":"参赛者须确保对作品中使用的软件、素材资源拥有版权或合法使用权。如果使用开源资源，需严格遵守其开源协议。参赛作品的版权归创作团队所有，但参赛即视为同意主办方世纪华通可在其相关网站和线下活动中免费使用提交的作品。世纪华通承诺对参赛者的个人信息及作品信息严格保密，不会在未经参赛者同意的前提下用于本活动以外的任何其他目的。",
    
    "other":"其他",
    'other_dec':"参赛者提交作品或报名信息后，即视为不可撤销地接受上述参赛须知以及世纪华通不时发布的相关协议和参赛规则。如因不可抗力或其他不可归责于世纪华通的原因导致活动无法正常进行或参赛者无法参与，世纪华通有权暂停或取消活动且无需承担任何责任。在法律法规允许的范围内，世纪华通保留对本次比赛规则进行修改、调整和最终解释的权利。",

    "person_one":"王佶",
    "person_one_position":"世纪华通董事长",

    "person_two":"方辉",
    "person_two_position":"世纪华通首席战略官",

    "person_three":"唐贾军",
    "person_three_position":"世纪华通首席战略官",

    "person_four":"丁晓玲",
    "person_four_position":"世纪华通首席战略官",

    "person_five":"张奇",
    "person_five_position":"复旦大学计算与智能创新学院",

    "person_six":"连冠荣",
    "person_six_position":"前腾讯游戏专家工程师 T13",


    "person_seven":"牛源蕾",
    "person_seven_position":"澎湃新闻CTO",

    "person_eight":"徐孩",
    "person_eight_position":"魔搭社区",

    "person_nine":"毛瑞卿",
    "person_nine_position":"Neuron Venture Partners – 创始合伙人",

    "person_ten":"暂无",
    "person_ten_position":"上海科技创业导师、华政国际知识产权研究中心执行主任 ",

    "person_ele":"张在伟",
    "person_ele_position":"盛趣游戏技术中心负责人",
    "person_twe":"吴时千",
    "person_twe_position":"盛趣游戏策划中心负责人",

    "Best_AI":"最佳AI游戏奖",
    "Awarded_to":"游戏性与技术融合创新", 
    "Awarded_to_one":"主奖1名，奖金￥50000",
    "Awarded_to_two":" 提名奖2名，奖金￥20000",

    "Best_tech":"最佳AI应用奖",
    "Best_awarded_to":"产品价值、用户体验与技术壁垒",
    "Best_awarded_to_one":"主奖1名，奖金￥50000",
    "Best_awarded_to_two":"提名奖2名，奖金￥20000 ",

    "Best_content":"最具商业价值奖",
    "Best_content_awarded":"数据验证与规模化潜力",
    "Best_content_awarded_one":"主奖1名，奖金￥50000",
    "Best_content_awarded_two":"提名奖2名，奖金￥20000",

    "Best_audio":"最佳新秀奖",
    "Best_audio_awarded":"创意突破与团队潜力（优先大学生团队）",
    "Best_audio_awarded_one":"主奖1名，奖金￥30000",
    "Best_audio_awarded_two":"提名奖2名，奖金￥10000",

    "Best_visual":"最佳“养虾”奖",
    "Best_visual_awarded":"AI智能体实操新标杆",
    "Best_visual_awarded_one":"主奖1名，奖金￥30000",

    "Best_rising":"最佳国际团队奖",
    "Best_rising_awarded":"海外团队的创新能力（限境外团队）",
    "Best_rising_awarded_one":"主奖1名，奖金￥30000",

    "contact_person_team_name": "联系人/团队名称：",
    "region": "所在地区：",
    "contact_information": "联系方式：",
    "contact_information_type": "(手机号/QQ号/微信/邮箱)",
    "openclaw_core_capability": "OpenClaw智能体核心能力描述：",
    "openclaw_skill_extension": "技能扩展/进化技术路径：",
    "openclaw_security_protection": "智能体安全防护设计说明：",
    "openclaw_demo_video": "智能体实操演示视频（网盘链接）：",
    "video_requirements": "视频要求：能清晰展示OpenClaw核心能力、扩展/进化的技能，以及安全防护全流程",
    "upload_instructions": "请将所有材料上传至网盘，生成分享链接并设置为永久有效。",
    "other_highlights": "其他亮点补充：",

 
    "数龙":"",
    "active_rule_one":'"数龙365"是什么?是由世纪华通发起,针对Al创新领域全年',
    "active_rule_one_one":"7×24",
    "active_rule_one_two":"运转的",
    "active_rule_one_three":"Al创新服务平台",

    "active_rule_two":"支持",
    "active_rule_two_one":"两大赛道",
    "active_rule_two_two":"项目投稿：Al游戏和AI应用",

    "active_rule_three":"每月",
    "active_rule_three_one":"优质项目将进入数龙AI月度盘点内容进行曝光展示",

    "active_rule_four":"月度优质项目可参加",
    "active_rule_four_one":"每季度",
    "active_rule_four_two":"由主办方组织的",
    "active_rule_four_three":"线下对接",
    "active_rule_four_four":"活动,与投资机构、产业伙伴面对面"
 

}   
  